import React, { useState } from 'react';
import { Snackbar, Alert, Link } from '@mui/material';
import Slide from '@mui/material/Slide';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';

// Utility function to display a Snackbar on the bottom left corner
// indicating that certain page or feature has been updated. It receives
// two parameters: displayUntil which controls until when the snackbar
// should be shown, and adminRights to display a reminder to admins to
// remove the code. It can also receive an anchor that will be used to
// refer the user to the specific release notes that apply to the feature
// this anchor must be added to the release note markdown manually.
const NewFeatureIndicator = ({ displayUntil, adminRights, releaseCode }) => {
  const [show, setShow] = useState(true);

  const currentTime = moment();

  const theme = createTheme({
    typography: {
      fontSize: 26
    }
  });

  let inner = null;

  if (currentTime.isBefore(displayUntil)) {
    inner = (
      <Alert severity="info">
        {I18n.t('new_feature.info')}{' '}
        <Link href={`/communication/releases/${releaseCode}`} color="inherit" target="_blank" rel="noopener">
          {I18n.t('release.label')}
        </Link>
      </Alert>
    );
  } else if (adminRights) {
    inner = <Alert severity="warning">{I18n.t('new_feature.admin_reminder')}</Alert>;
  }

  if (!inner) return null;

  return (
    <ThemeProvider theme={theme}>
      <Snackbar open={show} autoHideDuration={15_000} onClose={() => setShow(false)} TransitionComponent={Slide}>
        {inner}
      </Snackbar>
    </ThemeProvider>
  );
};

export default NewFeatureIndicator;
